import React from "react";
import { alpha } from "@mui/material/styles";
import { Alert, Box, Button, Paper, Stack, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

function ResultList({ t, resultado, passageiros }) {
  return (
    <Stack spacing={0.75}>
      {resultado.map((r, i) => (
        <Paper
          key={i}
          variant="outlined"
          sx={{
            py: 0.75,
            px: 1.25,
            borderRadius: 1.5,
            bgcolor: (theme) => alpha(theme.palette.success.main, 0.04),
          }}
        >
          {passageiros[i]?.nome && (
            <Typography variant="body2" fontWeight={700} lineHeight={1.3}>
              {passageiros[i].nome}
            </Typography>
          )}
          <Typography variant="caption" color="text.secondary" display="block">
            {t("bpeWizard.locator")}: {r.dados_bpe?.Localizador || r.reservationId || "—"}
            {" · "}
            {t("bpeWizard.bpeNumber")}: {r.dados_bpe?.NumeroBpe || "—"}
          </Typography>
        </Paper>
      ))}
    </Stack>
  );
}

/**
 * Passo concluído — resumo compacto da emissão (ida e, quando houver, volta).
 */
function deliveryMessage(t, deliveryInfo) {
  if (!deliveryInfo) return null;
  if (deliveryInfo.delivered) {
    if (deliveryInfo.mode === "file") return t("bpeWizard.deliverySentFile");
    if (deliveryInfo.mode === "link") return t("bpeWizard.deliverySentLink");
    return t("bpeWizard.deliverySent");
  }
  return t("bpeWizard.deliveryNotSent");
}

export default function BPeDoneStep({
  t,
  resultado,
  passageiros,
  onCopyToChat,
  outboundResults = null,
  outboundSummary = "",
  returnSummary = "",
  deliveryInfo = null,
}) {
  const hasOutbound = Array.isArray(outboundResults) && outboundResults.length > 0;
  const deliveryMsg = deliveryMessage(t, deliveryInfo);
  return (
    <Box>
      <Alert severity="success" icon={<CheckCircleOutlineIcon />} sx={{ py: 0.75, mb: 1.5 }}>
        <Typography variant="subtitle2" fontWeight={700}>
          {hasOutbound ? t("bpeWizard.successTitleRoundTrip") : t("bpeWizard.successTitle")}
        </Typography>
        <Typography variant="caption">{t("bpeWizard.successBodyShort")}</Typography>
      </Alert>

      {deliveryMsg && (
        <Alert
          severity={deliveryInfo?.delivered ? "info" : "warning"}
          sx={{ py: 0.25, mb: 1.5 }}
        >
          <Typography variant="caption">{deliveryMsg}</Typography>
        </Alert>
      )}

      {hasOutbound && (
        <Box sx={{ mb: 1.5 }}>
          <Typography variant="overline" color="text.secondary" sx={{ fontWeight: 700 }}>
            {t("bpeWizard.legIda")}
            {outboundSummary ? ` · ${outboundSummary}` : ""}
          </Typography>
          <ResultList t={t} resultado={outboundResults} passageiros={passageiros} />
        </Box>
      )}

      <Box sx={{ mb: 1.5 }}>
        {hasOutbound && (
          <Typography variant="overline" color="text.secondary" sx={{ fontWeight: 700 }}>
            {t("bpeWizard.legVolta")}
            {returnSummary ? ` · ${returnSummary}` : ""}
          </Typography>
        )}
        <ResultList t={t} resultado={resultado} passageiros={passageiros} />
      </Box>

      <Button
        variant="contained"
        startIcon={<ContentCopyIcon />}
        onClick={onCopyToChat}
        fullWidth
        sx={{ textTransform: "none" }}
      >
        {t("bpeWizard.copyToChat")}
      </Button>
    </Box>
  );
}
